module.exports = __webpack_public_path__ + "img/logo_avalanche.dda96f94.png";